import { ReactElement } from 'react';
import { Fieldset } from 'components';
import { BonusForm, RateGroups } from 'modules/guarantee/common/bonus';
import permissions from 'modules/guarantee/avb/permissions';
import { TextField } from '@ff-it/form';

export function Form(): ReactElement {
  return (
    <BonusForm sensitive={permissions.sensitive_info}>
      <Fieldset title="Signature person">
        <div className="form-row">
          <TextField name="signature_first_name" label="First name" className="col-md-6" />
          <TextField name="signature_last_name" label="Last name" className="col-md-6" />
        </div>
      </Fieldset>
      <RateGroups bonusType="AVB" />
    </BonusForm>
  );
}
